<div class="content-card">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2>{{ 'WALL-LeaveLimitsForTheCurrentYear' | translate }}</h2>
  </div>
  <div class="table-wrapper">
    @if (!!absenceLimits && !!absenceLimits.length) {
      <table class="table">
        <thead>
          <tr class="table__head-row">
            <th rowspan="2" class="table__head-cell table__head-cell--strong">{{ 'AbsenceType' | translate }}</th>
            <th colspan="2" class="table__head-cell table__head-cell--strong">{{ 'WALL-AmountDue' | translate }}</th>
            <th colspan="2" class="table__head-cell table__head-cell--strong">{{ 'WALL-AmountUsed' | translate }}</th>
            <th colspan="2" class="table__head-cell table__head-cell--strong">{{ 'WALL-AmountLeft' | translate }}</th>
          </tr>
          <tr class="table__head-row">
            <th class="table__head-cell">{{ 'WALL-DailyLeave' | translate }}</th>
            <th class="table__head-cell">{{ 'WALL-HourlyLeave' | translate }}</th>
            <th class="table__head-cell">{{ 'WALL-DailyLeave' | translate }}</th>
            <th class="table__head-cell">{{ 'WALL-HourlyLeave' | translate }}</th>
            <th class="table__head-cell">{{ 'WALL-DailyLeave' | translate }}</th>
            <th class="table__head-cell">{{ 'WALL-HourlyLeave' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @if (findByAbsenceLimitTypeId(AbsenceLimitType.Vacation)) {
            <tr class="table-row">
              <td>
                <strong>{{ 'WALL-Leave' | translate }}</strong>
              </td>
              <td>
                <strong>{{ (absenceLimits | findPurely : absenceLimitFilter(AbsenceLimitType.Vacation))?.Due?.Days }}</strong>
              </td>
              <td>
                <strong>{{ (absenceLimits | findPurely : absenceLimitFilter(AbsenceLimitType.Vacation))?.Due?.Hours | toHoursAndMinutes }}</strong>
              </td>
              <td>
                <strong>{{ (absenceLimits | findPurely : absenceLimitFilter(AbsenceLimitType.Vacation))?.DueUsed?.Days }}</strong>
              </td>
              <td>
                <strong>{{ (absenceLimits | findPurely : absenceLimitFilter(AbsenceLimitType.Vacation))?.DueUsed?.Hours | toHoursAndMinutes }}</strong>
              </td>
              <td>
                <strong>{{ (absenceLimits | findPurely : absenceLimitFilter(AbsenceLimitType.Vacation))?.DueLeft?.Days }}</strong>
              </td>
              <td>
                <strong>{{ (absenceLimits | findPurely : absenceLimitFilter(AbsenceLimitType.Vacation))?.DueLeft?.Hours | toHoursAndMinutes }}</strong>
              </td>
            </tr>
          }
          @if (findByAbsenceLimitTypeId(AbsenceLimitType.Vacation)) {
            <tr class="table-row">
              <td>{{ 'WALL-LeaveOverdue' | translate }}</td>
              <td>{{ (absenceLimits | findPurely : absenceLimitFilter(AbsenceLimitType.Vacation))?.Overdue?.Days }}</td>
              <td>{{ (absenceLimits | findPurely : absenceLimitFilter(AbsenceLimitType.Vacation))?.Overdue?.Hours | toHoursAndMinutes }}</td>
              <td>{{ (absenceLimits | findPurely : absenceLimitFilter(AbsenceLimitType.Vacation))?.OverdueUsed?.Days }}</td>
              <td>{{ (absenceLimits | findPurely : absenceLimitFilter(AbsenceLimitType.Vacation))?.OverdueUsed?.Hours | toHoursAndMinutes }}</td>
              <td>{{ (absenceLimits | findPurely : absenceLimitFilter(AbsenceLimitType.Vacation))?.OverdueLeft?.Days }}</td>
              <td>{{ (absenceLimits | findPurely : absenceLimitFilter(AbsenceLimitType.Vacation))?.OverdueLeft?.Hours | toHoursAndMinutes }}</td>
            </tr>
          }
          @if (findByAbsenceLimitTypeId(AbsenceLimitType.Vacation)) {
            <tr class="table-row">
              <td>{{ 'WALL-LeaveDue' | translate }}</td>
              <td>{{ (absenceLimits | findPurely : absenceLimitFilter(AbsenceLimitType.Vacation))?.Current?.Days }}</td>
              <td>{{ (absenceLimits | findPurely : absenceLimitFilter(AbsenceLimitType.Vacation))?.Current?.Hours | toHoursAndMinutes }}</td>
              <td>{{ (absenceLimits | findPurely : absenceLimitFilter(AbsenceLimitType.Vacation))?.CurrentUsed?.Days }}</td>
              <td>{{ (absenceLimits | findPurely : absenceLimitFilter(AbsenceLimitType.Vacation))?.CurrentUsed?.Hours | toHoursAndMinutes }}</td>
              <td>{{ (absenceLimits | findPurely : absenceLimitFilter(AbsenceLimitType.Vacation))?.CurrentLeft?.Days }}</td>
              <td>{{ (absenceLimits | findPurely : absenceLimitFilter(AbsenceLimitType.Vacation))?.CurrentLeft?.Hours | toHoursAndMinutes }}</td>
            </tr>
          }
          @if (findByAbsenceLimitTypeId(AbsenceLimitType.Vacation)) {
            <tr class="table-row">
              <td>{{ 'WALL-LeaveOnDemand' | translate }}</td>
              <td>{{ findByAbsenceLimitTypeId(AbsenceLimitType.OnDemand)?.Due?.Days }}</td>
              <td>-</td>
              <td>{{ findByAbsenceLimitTypeId(AbsenceLimitType.OnDemand)?.DueUsed?.Days }}</td>
              <td>-</td>
              <th>{{ findByAbsenceLimitTypeId(AbsenceLimitType.OnDemand)?.DueLeft?.Days }}</th>
              <th>-</th>
            </tr>
          }
          @if (findByAbsenceLimitTypeId(AbsenceLimitType.ChildCare)) {
            <tr class="table-row">
              <td>
                <strong>{{ 'WALL-ChildCareLeave' | translate }}</strong>
              </td>
              <td>
                <strong>{{ findByAbsenceLimitTypeId(AbsenceLimitType.ChildCare)?.Due?.Days ?? '-' }}</strong>
              </td>
              <td>
                <strong>{{
                  findByAbsenceLimitTypeId(AbsenceLimitType.ChildCare)?.Due?.Hours !== null
                  ? (findByAbsenceLimitTypeId(AbsenceLimitType.ChildCare)?.Due?.Hours | toHoursAndMinutes)
                  : '-'
                }}</strong>
              </td>
              <td>
                <strong>{{ findByAbsenceLimitTypeId(AbsenceLimitType.ChildCare)?.DueUsed?.Days ?? '-' }}</strong>
              </td>
              <td>
                <strong>{{
                  findByAbsenceLimitTypeId(AbsenceLimitType.ChildCare)?.DueUsed?.Hours !== null
                  ? (findByAbsenceLimitTypeId(AbsenceLimitType.ChildCare)?.DueUsed?.Hours | toHoursAndMinutes)
                  : '-'
                }}</strong>
              </td>
              <td>
                <strong>{{ findByAbsenceLimitTypeId(AbsenceLimitType.ChildCare)?.DueLeft?.Days ?? '-' }}</strong>
              </td>
              <td>
                <strong>{{
                  findByAbsenceLimitTypeId(AbsenceLimitType.ChildCare)?.DueLeft?.Hours !== null
                  ? (findByAbsenceLimitTypeId(AbsenceLimitType.ChildCare)?.DueLeft?.Hours | toHoursAndMinutes)
                  : '-'
                }}</strong>
              </td>
            </tr>
          }
          @if (findByAbsenceLimitTypeId(AbsenceLimitType.DayOffApplication)) {
            <tr class="table-row">
              <td>
                <strong>{{ 'WALL-DayOffApplication' | translate }}</strong>
              </td>
              <td>
                <strong>{{ findByAbsenceLimitTypeId(AbsenceLimitType.DayOffApplication)?.Due?.Days }}</strong>
              </td>
              <td>
                <strong>{{ findByAbsenceLimitTypeId(AbsenceLimitType.DayOffApplication)?.Due?.Hours | toHoursAndMinutes }}</strong>
              </td>
              <td>
                <strong>{{ findByAbsenceLimitTypeId(AbsenceLimitType.DayOffApplication)?.DueUsed?.Days }}</strong>
              </td>
              <td>
                <strong>{{ findByAbsenceLimitTypeId(AbsenceLimitType.DayOffApplication)?.DueUsed?.Hours | toHoursAndMinutes }}</strong>
              </td>
              <td>
                <strong>{{ findByAbsenceLimitTypeId(AbsenceLimitType.DayOffApplication)?.DueLeft?.Days }}</strong>
              </td>
              <td>
                <strong>{{ findByAbsenceLimitTypeId(AbsenceLimitType.DayOffApplication)?.DueLeft?.Hours | toHoursAndMinutes }}</strong>
              </td>
            </tr>
          }
          @if (findByAbsenceLimitTypeId(AbsenceLimitType.JobSearchLeave)) {
            <tr class="table-row">
              <th>{{ 'WALL-JobSearchLeave' | translate }}</th>
              <th>{{ findByAbsenceLimitTypeId(AbsenceLimitType.JobSearchLeave)?.Due?.Days }}</th>
              <th>{{ findByAbsenceLimitTypeId(AbsenceLimitType.JobSearchLeave)?.Due?.Hours }}</th>
              <th>{{ findByAbsenceLimitTypeId(AbsenceLimitType.JobSearchLeave)?.DueUsed?.Days }}</th>
              <th>{{ findByAbsenceLimitTypeId(AbsenceLimitType.JobSearchLeave)?.DueUsed?.Hours | toHoursAndMinutes }}</th>
              <th>{{ findByAbsenceLimitTypeId(AbsenceLimitType.JobSearchLeave)?.DueLeft?.Days }}</th>
              <th>{{ findByAbsenceLimitTypeId(AbsenceLimitType.JobSearchLeave)?.DueLeft?.Hours | toHoursAndMinutes }}</th>
            </tr>
          }
          @if (findByAbsenceLimitTypeId(AbsenceLimitType.UnpaidCareLeave)) {
            <tr class="table-row">
              <th>{{ 'WALL-UnpaidLeaveCare' | translate }}</th>
              <th>{{ findByAbsenceLimitTypeId(AbsenceLimitType.UnpaidCareLeave)?.Due?.Days }}</th>
              <th>-</th>
              <th>{{ findByAbsenceLimitTypeId(AbsenceLimitType.UnpaidCareLeave)?.DueUsed?.Days }}</th>
              <th>-</th>
              <th>{{ findByAbsenceLimitTypeId(AbsenceLimitType.UnpaidCareLeave)?.DueLeft?.Days }}</th>
              <th>-</th>
            </tr>
          }
          @if (findByAbsenceLimitTypeId(AbsenceLimitType.ForceMajeureLeave)) {
            <tr class="table-row">
              <th>{{ 'WALL-ForceMajeureLeave' | translate }}</th>
              <th>{{ findByAbsenceLimitTypeId(AbsenceLimitType.ForceMajeureLeave)?.Due?.Days ?? '-' }}</th>
              <th>
                {{
                findByAbsenceLimitTypeId(AbsenceLimitType.ForceMajeureLeave)?.Due?.Hours !== null
                ? (findByAbsenceLimitTypeId(AbsenceLimitType.ForceMajeureLeave)?.Due?.Hours | toHoursAndMinutes)
                : '-'
                }}
              </th>
              <th>{{ findByAbsenceLimitTypeId(AbsenceLimitType.ForceMajeureLeave)?.DueUsed?.Days ?? '-' }}</th>
              <th>
                {{
                findByAbsenceLimitTypeId(AbsenceLimitType.ForceMajeureLeave)?.DueUsed?.Hours !== null
                ? (findByAbsenceLimitTypeId(AbsenceLimitType.ForceMajeureLeave)?.DueUsed?.Hours | toHoursAndMinutes)
                : '-'
                }}
              </th>
              <th>{{ findByAbsenceLimitTypeId(AbsenceLimitType.ForceMajeureLeave)?.DueLeft?.Days ?? '-' }}</th>
              <th>
                {{
                findByAbsenceLimitTypeId(AbsenceLimitType.ForceMajeureLeave)?.DueLeft?.Hours !== null
                ? (findByAbsenceLimitTypeId(AbsenceLimitType.ForceMajeureLeave)?.DueLeft?.Hours | toHoursAndMinutes)
                : '-'
                }}
              </th>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</div>
